import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TextField from '@material-ui/core/TextField';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../reducers';

import * as Actions from '../actions/user';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/UserScenarioFactory';
import SelectUserTable from './SelectUserTable';

const styles = (theme: Theme) =>
	createStyles({
		fullWidth: {
			width: '100%',
		},
		root: {
			flexGrow: 1,
			height: '400px',
			padding: 24,
			width: '1100px',
		},
	});

interface IState {
	loginId: string;
	searchWord: string;
	userFamilyName: string;
	userName: string;
}

/**
 * ユーザ選択
 */
class SelectUser extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			loginId: '',
			searchWord: '',
			userFamilyName: '',
			userName: '',
		};

		this.onChange = this.onChange.bind(this);
		this.search = this.search.bind(this);
	}

	public render() {
		const { classes } = this.props;
		return (
			<Dialog
				open={this.props.open}
				onClose={this.props.onClose}
				maxWidth={false}
			>
				<DialogContent>
					<div className={classes.root}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={3}>
								<div>
									<Button
										variant="contained"
										color="primary"
										onClick={this.search}
									>
										{i18n.t('SelectUser_0001')}
									</Button>
								</div>
								<div>
									<TextField
										label={i18n.t('SelectUser_0002')}
										name="searchWord"
										value={this.state.searchWord}
										onChange={this.onChange}
										className={classes.fullWidth}
									/>
								</div>
								<div>
									<TextField
										label={i18n.t('SelectUser_0003')}
										name="loginId"
										value={this.state.loginId}
										onChange={this.onChange}
										className={classes.fullWidth}
									/>
								</div>
								<div>
									<TextField
										label={i18n.t('SelectUser_0004')}
										name="userFamilyName"
										value={this.state.userFamilyName}
										onChange={this.onChange}
										className={classes.fullWidth}
									/>
								</div>
								<div>
									<TextField
										label={i18n.t('SelectUser_0005')}
										name="userName"
										value={this.state.userName}
										onChange={this.onChange}
										className={classes.fullWidth}
									/>
								</div>
							</Grid>
							<Grid item={true} xs={9}>
								<SelectUserTable
									data={this.props.selectUsers.data}
									selectedColumns={
										this.props.selectUsers.selectedColumns
									}
									onSelect={this.props.onSelect}
								/>
							</Grid>
						</Grid>
					</div>
				</DialogContent>
			</Dialog>
		);
	}

	/**
	 * 値変更処理
	 * @param e イベントオブジェクト
	 */
	protected onChange(e: React.ChangeEvent<HTMLInputElement>) {
		const { name, value } = e.target;
		const newState = {};
		newState[name] = value;
		this.setState(newState);
	}

	/**
	 * 検索処理
	 */
	protected search() {
		const condition: Actions.ISelectUserSearchCondition = {
			...this.state,
		};

		this.props.fetchSelectUsers(this.props.token, condition);
	}
}

const mapStateToProps = (state: IRootState) => ({
	selectUsers: state.user.selectUsers,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchSelectUsers: (
		token: string,
		condition: Actions.ISelectUserSearchCondition
	) => {
		const s = ScenarioFactory.createFetchSelectUsers(dispatch, token);
		s.run(condition);
	},
});

export interface ISelectUserProps {
	open: boolean;
	onClose: () => void;
	onSelect: (selectUser: Actions.ISelectUser) => void;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISelectUserProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SelectUser);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/SelectUser.tsx